/**
 *
 * @module dateRegex
 *
 */

const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

/**
 *
 * @param {String} dateString
 * @desc tests a string to see if it represents a date that conforms to ISO-8601 standard
 * @returns {Boolean}
 *
 * @example dateRegex('2019-05-09T18:14:21.559Z');
 * @example dateRegex(new Date().toISOString());
 *
 */
export default (dateString) => {

    return dateRegex.test(dateString);

};



// WEBPACK FOOTER //
// ./src/services/util/dateRegex.js